module.exports = __webpack_public_path__ + "./rules/SportsRulesPT.229de40ad43c19cb13c505ab8f95c0d2.pdf";